<template>
  <div v-if="showForm">
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="column container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <h5 v-if="formType == 'edit'" class="form-header">
              Editar {{ equipment }} {{ oldName }}
            </h5>
            <h5 v-else class="form-header">Adicionar {{ equipment }}</h5>
          </div>
          <div class="col-xs-12">
            <!-- <b-form-text v-show="form.NAME">Nome *</b-form-text> -->
            <b-form-text id="nameInput">Nome *</b-form-text>
            <b-form-input
              v-model="form.NAME"
              placeholder="Nome *"
              :formatter="notEmpty"
              maxlength="24"
              size="sm"
              aria-describedby="nameInput nameInputLiveFeedback"
              :state="nameState && notRepeatedName"
              id="nameInput"
            />
            <b-form-invalid-feedback
              v-if="!nameState"
              id="nameInputLiveFeedback"
            >
              Obrigatório. Permitidos apenas letras, números, pontos, hífens e
              underlines.
            </b-form-invalid-feedback>
            <b-form-invalid-feedback v-if="!notRepeatedName" id="nameInput">
              Esse nome já está em uso
            </b-form-invalid-feedback>
            <b-form-text id="input-model">Modelo *</b-form-text>
            <!-- <b-form-text v-show="form.FK_MODEL">Modelo *</b-form-text> -->
            <b-form-select
              v-model="form.FK_MODEL"
              :options="actuatorsModels"
              text-field="NAME"
              value-field="ID"
              size="sm"
              aria-describedby="modelSelectLiveFeedback"
              :state="modelState"
              id="input-model"
            >
              <template slot="first">
                <option :value="null" disabled>Selecione o modelo *</option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback
              v-if="!modelState"
              id="modelSelectLiveFeedback"
            >
              Obrigatório.
            </b-form-invalid-feedback>
          </div>

          <div class="col-xs-12">
            <div class="group-inputs-title">Localização</div>
            <b-form-text id="input-latitude">Latitude</b-form-text>
            <!-- <b-form-text v-show="form.LATITUDE">Latitude</b-form-text> -->
            <b-form-input
              v-model="form.LATITUDE"
              placeholder="Latitude"
              aria-describedby="latInputLiveFeedback"
              :state="LATstate"
              :formatter="notEmpty"
              maxlength="40"
              size="sm"
              id="input-latitude"
            />
            <b-form-invalid-feedback v-if="!LATstate" id="latInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Latitudes não podem ter valor menor que
              -90 ou maior que 90 graus.
            </b-form-invalid-feedback>
            <b-form-text id="input-latitude">Longitude</b-form-text>
            <!-- <b-form-text v-show="form.LONGITUDE">Longitude</b-form-text> -->
            <b-form-input
              v-model="form.LONGITUDE"
              placeholder="Longitude"
              aria-describedby="lonInputLiveFeedback"
              :state="LONstate"
              :formatter="notEmpty"
              maxlength="40"
              size="sm"
              id="input-latitude"
            />
            <b-form-invalid-feedback v-if="!LONstate" id="lonInputLiveFeedback">
              Permitidos apenas números, um único ponto decimal e um único hífen
              indicando valor negativo. Longitudes não podem ter valor menor que
              -180 ou maior que 180 graus.
            </b-form-invalid-feedback>
          </div>
          <div class="col-xs-12">
            <div class="group-inputs-title">Parâmetros</div>
            <b-form-text id="closureTimeInputLiveHelp">
              Tempo de fechamento (s)
            </b-form-text>
            <b-form-input
              v-model="form.CLOSURE_TIME"
              type="number"
              min="1"
              size="sm"
              aria-describedby="closureTimeInputLiveHelp"
              state="valid"
            />
            <b-form-text id="closureTimeInputLiveHelp">
              Tempo de descanso (min)
            </b-form-text>
            <b-form-input
              v-model="form.REST_TIME"
              type="number"
              min="0"
              size="sm"
              aria-describedby="closureTimeInputLiveHelp"
              state="valid"
            />
            <b-form-text id="input-pres">
              Pressão requerida (bar)
            </b-form-text>
            <!-- <b-form-text v-show="form.REQ_PRES">
              Pressão requerida (bar)
            </b-form-text> -->

            <b-form-input
              v-model="form.REQ_PRES"
              placeholder="Informe a pressão"
              :formatter="notEmpty"
              :state="reqPresState"
              id="input-pres"
              size="sm"
            />
          </div>
          <div class="col-xs-12">
            <div class="group-inputs-title">Equipamentos associados</div>
            <b-form-text >Sensor</b-form-text>
            <!-- <b-form-text v-show="form.FK_SENSOR">Sensor</b-form-text> -->
            <b-form-select
              v-model="form.FK_SENSOR"
              :options="sensors"
              text-field="NAME"
              value-field="ID"
              state="valid"
              size="sm"
            >
              <template slot="first">
                <option :value="null">Sensor</option>
              </template>
            </b-form-select>
            <b-form-text v-show="form.FK_SENSOR && form.POS_SENSOR"
              >Medição do Sensor</b-form-text
            >
            <b-form-select
              v-if="form.FK_SENSOR"
              v-model="form.POS_SENSOR"
              :state="sensorMeasureToActuatorState"
              size="sm"
            >
              <template slot="first">
                <option :value="null">Medição do sensor</option>
              </template>
              <!-- olhar aqui -->
              <option
                v-for="(measure, index) in auxSensors.filter(
                  (e) => e.ID == form.FK_SENSOR
                )"
                :key="index"
                :value="measure.POS"
              >
                {{ measure.NAME_TYPE }} ({{ measure.NAME_UNIT }})
              </option>
            </b-form-select>
            <b-form-text id="input-hydro">Hidrômetro</b-form-text>
            <!-- <b-form-text v-show="form.FK_HYDRO">Hidrômetro</b-form-text> -->
            <b-form-select
              v-model="form.FK_HYDRO"
              :options="hydros"
              text-field="NAME"
              value-field="ID"
              state="valid"
              size="sm"
              id="input-hydro"
            >
              <template slot="first">
                <option :value="null">Selecione o hidrômetro</option>
              </template>
            </b-form-select>

            <b-form-text id="input-obs">Observações</b-form-text>
            <!-- <b-form-text v-show="form.NOTE">Observações</b-form-text> -->
            <b-form-input
              v-model="form.NOTE"
              placeholder="Observações"
              state="valid"
              maxlength="40"
              size="sm"
              id="input-obs"
            />
          </div>
        </b-form>
      </div>
      <b-modal
       ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >

        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Não é possível salvar os dados do formulário porque
          </div>

          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="$refs.formError.hide"
          >Irei corrigir</b-btn
        >
      </b-modal>
      <footer id="footer" class="pb-2">
        <b-btn size="sm" variant="outline-secondary" block @click="$emit('close-form')"> Fechar </b-btn>
        <b-btn variant="3v3" @click="checkForm" size="sm" class="ml-1"> Salvar </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  checkLAT,
  checkLON,
  testName,
  notEmpty,
  notRepeatedName
} from "@/pages/components/regist/form-functions";
export default {
  name: "pump-form",
  props: {
    showForm: Boolean,
    equipment: String,
    oldName: String,
    formType: String,
    alreadyUsedNames: Array,
    actuatorsModels: Array,
    hydros: Array,
    sensors:{
      type:Array,
      default(){
        return []
      }
    },
    auxSensors: Array,
    itemToEdit: [Number, Object]
  },
  data() {
    return {
      errors: [],
      form: {
        NAME: "",
        FK_MODEL: null,
        CLOSURE_TIME: null,
        REST_TIME: null,
        LATITUDE: null,
        LONGITUDE: null,
        FK_HYDRO: null,
        FK_SENSOR: null,
        POS_SENSOR: null,
        REQ_PRES: null,
        NOTE: null
      }
    };
  },
  watch: {
    showForm(newVal, oldVal) {
      if (!oldVal && newVal) {
        if (this.formType == "add") this.resetForm();
        else {
          this.form.ID = this.itemToEdit.ID; //IMPORTANTE PARA DIFERENCIAR EDIÇÃO DE ADIÇÃO
          this.form.NAME = this.itemToEdit.NAME;
          this.form.LAST_NAME = this.itemToEdit.NAME;
          this.form.FK_MODEL = this.itemToEdit.FK_MODEL;
          this.form.FK_SENSOR = this.itemToEdit.FK_SENSOR;
          this.form.POS_SENSOR = this.itemToEdit.POS_SENSOR;
          this.form.CLOSURE_TIME = this.itemToEdit.CLOSURE_TIME;
          this.form.REST_TIME = this.itemToEdit.REST_TIME;
          this.form.LATITUDE = this.itemToEdit.LATITUDE;
          this.form.LONGITUDE = this.itemToEdit.LONGITUDE;
          this.form.REQ_PRES = this.itemToEdit.REQ_PRES;
          this.form.FK_HYDRO = this.itemToEdit.FK_HYDRO;
          this.form.NOTE = this.itemToEdit.NOTE;
        }
      }
    }
  },
  computed: {
    nameState() {
      return testName(this.form.NAME);
    },
    modelState() {
      return !!this.form.FK_MODEL;
    },
    LATstate() {
      let LAT = String(Number(this.form.LATITUDE));
      return checkLAT(LAT);
    },
    LONstate() {
      let LON = String(Number(this.form.LONGITUDE));
      return checkLON(LON);
    },
    reqPresState() {
      let reqPres = String(Number(this.form.REQ_PRES));
      if (reqPres == "NaN" || reqPres < 0) return false;
      return true;
    },
    notRepeatedName() {
      return notRepeatedName(
        this.alreadyUsedNames,
        this.form.NAME,
        this.formType,
        this.oldName
      );
    },
    sensorMeasureToActuatorState() {
      if (this.form.FK_SENSOR && this.form.POS_SENSOR === null) return false;
      return true;
    },
  },
  methods: {
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.form = {
        NAME: "",
        FK_MODEL: null,
        FK_SENSOR: null,
        POS_SENSOR: null,
        CLOSURE_TIME: null,
        REST_TIME: null,
        LATITUDE: null,
        LONGITUDE: null,
        FK_HYDRO: null,
        REQ_PRES: null,
        NOTE: null
      };
    },
    checkForm() {
      this.errors = [];
      let states = [
        this.nameState,
        this.notRepeatedName,
        this.modelState,
        this.LATstate,
        this.LONstate
      ];
      let erros = [
        "Nome é obrigatório. Permitidos apenas letras, números, pontos, hífens e underlines. Espaços NÃO são permitidos.",
        "Nome escolhido já está em uso. Verifique.",
        "O equipmamento precisa ter um modelo.",
        "Latitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Latitudes não podem ter valor menor que -90 ou maior que 90 graus.",
        "Longitude: Permitidos apenas números, um único ponto decimal e um único hífen indicando valor negativo. Longitudes não podem ter valor menor que -180 ou maior que 180 graus."
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      this.form.LATITUDE =
        this.form.LATITUDE != "" && this.form.LATITUDE != null
          ? parseFloat(this.form.LATITUDE)
          : null;
      this.form.LONGITUDE =
        this.form.LONGITUDE != "" && this.form.LONGITUDE != null
          ? parseFloat(this.form.LONGITUDE)
          : null;
      this.form.REQ_PRES =
        this.form.REQ_PRES != "" && this.form.REQ_PRES != null
          ? parseFloat(this.form.REQ_PRES)
          : null;
      this.form.CLOSURE_TIME =
        this.form.CLOSURE_TIME > 0 || this.form.CLOSURE_TIME == null
          ? this.form.CLOSURE_TIME
          : null;

      if (this.form.POS_SENSOR == null) this.form.ACTION_SENSOR = null;
      else if (this.form.ACTION_SENSOR == null) this.form.ACTION_SENSOR = 0;

      this.form.REST_TIME =
        this.form.REST_TIME >= 0 || this.form.REST_TIME == null
          ? this.form.REST_TIME
          : null;
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.$emit("submit", this.form);
        this.$emit("close-form");
      }
    }
  }
};
</script>

<style scoped>
#form{
  padding-left: 0;
  padding-right: 0;
}
@media screen and (max-width: 768px) {
  .container-form{
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0em;
    margin-right: 0;
  }

}
</style>
